import React from "react";
import { useToast } from "../../../hooks/use-toast";
import "./style.css";

const Toaster = () => {
  const { toasts, dismiss } = useToast();

  return (
    <div className="toast-viewport">
      {toasts.map(({ id, title, description, action, open }) => (
        <div key={id} className={`toast ${open ? "open" : "closed"}`}>
          <div className="toast-content">
            {title && <div className="toast-title">{title}</div>}
            {description && <div className="toast-description">{description}</div>}
          </div>
          {action && <div className="toast-action">{action}</div>}
          <button className="toast-close" onClick={() => dismiss(id)}>×</button>
        </div>
      ))}
    </div>
  );
};

export default Toaster;
